import React from 'react';
import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
function Header() {
  const navigate = useNavigate();
  const [activeDropdown, setActiveDropdown] = useState(null);
  const dropdownRef = useRef(null);
  const [user, setUser] = useState(null);

  // Fetch user details from localStorage
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser)); // Parse JSON string to object
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActiveDropdown(null);
      }
    };

    window.addEventListener('click', handleClickOutside);

    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const toggleDropdown = (dropdownId) => {
    setActiveDropdown(activeDropdown === dropdownId ? null : dropdownId);
  };

  // Handle Sign Out
  const handleSignOut = () => {
    localStorage.removeItem("user"); // Clear session
    navigate("/login"); // Redirect to login page
  };

  return (
    <header id="header" className="header fixed-top d-flex align-items-center">

      <div className="d-flex align-items-center justify-content-between">
        <a className="logo d-flex align-items-center" href="/admin/orderList">
          <img src="/assets/img/bilipatra_logo.png" alt="" />
          <span className="d-none d-lg-block">BILIPATRA</span>
        </a>
        <i className="bi bi-list toggle-sidebar-btn">
        </i>
      </div>{/* End logo */}

      <nav className="header-nav ms-auto">
        <ul className="d-flex align-items-center">

          <li className="nav-item dropdown pe-3" ref={dropdownRef}>

            <a className="nav-link nav-profile d-flex align-items-center pe-0" href="//" onClick={() => toggleDropdown('profile')} data-bs-toggle="dropdown">
              <img src="/assets/img/avatar.jpg" alt="Profile" className="rounded-circle" />
              <span className="d-none d-md-block dropdown-toggle ps-2">{user?.store_name || "User Name"}</span>
            </a>{/* End Profile Iamge Icon */}

            <ul className={`dropdown-menu dropdown-menu-end dropdown-menu-arrow profile ${activeDropdown === 'profile' ? 'show' : ''}`}
              aria-labelledby="navbarDropdown">
              <li className="dropdown-header">
                <h6>{user?.store_name || "User Name"}</h6>
                {/* <span>{user?.emp_type || "Role"}</span> */}
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>

              <li>
                <a className="dropdown-item d-flex align-items-center" href="/admin/profile">
                  <i className="bi bi-person"></i>
                  <span>My Profile</span>
                </a>
              </li>

              <li>
                <hr className="dropdown-divider" />
              </li>

              <li>
                <a className="dropdown-item d-flex align-items-center" onClick={handleSignOut}>
                  <i className="bi bi-box-arrow-right"></i>
                  <span>Sign Out</span>
                </a>
              </li>
            </ul>{/* End Profile Dropdown Items */}
          </li>{/* End Profile Nav*/}
        </ul>
      </nav > {/* End Icons Navigation*/}
    </header >
  );
}

export default Header;
